import {
  Divider as ChakraDivider,
  type SystemStyleObject,
  useTheme,
} from '@chakra-ui/react';
import { UnnamedWidget } from 'lib-node-amb-renderer';

export class DividerClass extends UnnamedWidget {
  isExtraction;
  constructor(props) {
    super(props);
    this.isExtraction = props.isExtraction;
  }
}

type DividerProps = {
  sx?: SystemStyleObject;
  isExtraction?: boolean;
};

export default function Divider({ sx, isExtraction }: Readonly<DividerProps>) {
  const { colors } = useTheme();

  const defaultStyles = {
    border: '2px solid',
    borderColor: sx?.borderColor ? sx?.borderColor : `${colors?.blue[600]}`,
    ...sx,
  };
  const extractionStyles = {
    borderTop: `1px solid ${colors?.gray[100]}`,
    padding: 0,
    borderBottomWidth: 'none',
    opacity: 1,
    ...sx,
  };

  return (
    <ChakraDivider
      orientation="horizontal"
      sx={isExtraction ? extractionStyles : defaultStyles}
    />
  );
}
